var map = {
	"./gs/NewUi": 936,
	"./gs/NewUi.js": 936,
	"./gs/OldUi": 937,
	"./gs/OldUi.js": 937,
	"./spireon/SpireonNew": 938,
	"./spireon/SpireonNew.js": 938,
	"./spireon/SpireonOld": 939,
	"./spireon/SpireonOld.js": 939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;